export default "__VITE_ASSET__DpJZ8kP7__"